import React from "react";
import wechatQr from "../../assets/img/WechatQrCode.jpg";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

function UserWechatPg() {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [theme] = useTheme();

    const moveToMainPg = (() => {
        navigate("/")
    })

    return (
        <div className="up-scope up-page" data-theme={theme}>
            <div className="up-result-wrap">
                <div className="up-result">
                    <div className="up-card" style={{padding: "30px 26px"}}>
                        <p style={{margin: 0, color: "#2FB86B", fontSize: "24px", fontFamily: "'LINESeedKR-Bd', sans-serif"}}>WeChat</p>
                        <img src={wechatQr} alt="QRcode"
                             style={{width: "230px", maxWidth: "70vw", height: "auto", borderRadius: "14px", margin: "18px auto 20px", display: "block"}}/>
                        <p style={{margin: 0, fontSize: "17px", fontWeight: "bold", color: "var(--up-text)"}}>{t('uwpTx1')}</p>
                        <p style={{margin: "8px 0 0", fontSize: "14px", color: "var(--up-text-sub)"}}>{t('uwpTx2')}</p>
                    </div>
                    <div className="up-btn-row" style={{justifyContent: "center", marginTop: "18px"}}>
                        <button className="up-btn-primary" style={{height: "48px", fontSize: "15px", maxWidth: "180px", margin: "0 auto"}}
                                onClick={moveToMainPg}>HOME
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserWechatPg
